module.exports = __webpack_public_path__ + "img/programa_mundial_de_alimentos.1f8f9535.jpeg";